/*=========================================================================================
  File Name: moduleLegalEntityGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  legalEntity: state => {
    if (state.legalEntity !== null) {
      return state.legalEntity
    }
    return null
  },
  legalEntityId: state => {
    if (state.legalEntity !== null) {
      return state.legalEntity.id
    }
    return null
  },
  peopleId: state => {
    if (!state.legalEntity || !state.legalEntity.pleople) {
      return null
    }
    return state.legalEntity.pleople.id
  }
}
